export default {
  app: {
    orgCode: "그룹/브랜드 번호",
    orgCodePlaceholder: "그룹/브랜드 번호를 입력하세요",
    username: "계정",
    usernamePlaceholder: "계정을 입력하세요",
    password: "비밀번호",
    passwordPlaceholder: "비밀번호를 입력해주세요",
    captcha: "확인 코드",
    captchaPlaceholder: "인증 코드를 입력 해주세요",
    captchaExpired: "인증 코드를 새로 고침하십시오",
    login: "로그인",
    remember: "로그인 정보 기억하기",
    switchPC: "백엔드로 전환",
    mobileVersion: "모바일 BI",
    desktopVersion: "가맹점 백엔드",
    setupPassword: "암호를 설정하세요",
    newPassword: "새 비밀번호",
    newPasswordPlaceholder: "새로운 비밀번호를 입력해주세요",
    retypePassword: "새 비밀번호를 다시 입력하세요.",
    retypePasswordPlaceholder: "새 비밀번호를 다시 입력해주세요",
    setupPasswordRule: "비밀번호는 6-32자이며 숫자, 문자, 기호 중 두 가지 이상을 포함해야 합니다.",
    setupPasswordRuleRefer: "비밀번호는 6~32자 이내로 숫자, 문자, 기호를 2개 이상 조합하여 입력해야 합니다. 다시 입력해 주세요.",
    setupPasswordOk: "확신하는",
    setupPasswordDiffer: "두 번 입력한 비밀번호가 일치하지 않습니다. 다시 입력해 주세요.",
    err_def: "로그인 실패, 페이지를 새로고침하고 다시 시도하십시오.",
    err_2000: "인증코드 입력 오류입니다.",
    err_2010: "입력된 로그인 정보가 잘못되었습니다.",
    err_4001: "이 계정은 어떤 기능에도 승인되지 않습니다.",
    err_4011: "매장이 비활성화되었습니다, 로그인할 수 없습니다.",
    err_4012: "가맹점이 비활성화되었습니다, 로그인할 수 없습니다.",
    err_4013: "브랜드가 비활성화되었습니다, 로그인할 수 없습니다.",
    err_4014: "그룹이 비활성화되었습니다, 로그인할 수 없습니다.",
    err_4015: "영역이 비활성화되어 로그인할 수 없습니다.",
    err_4401: "이 계정은 해당 매장에 권한이 없습니다.",
    err_4402: "이 계정에는 관리자 권한이 없어 인증 코드를 받을 수 없습니다.",
    err_5001: "비밀번호 설정에 실패했습니다. 다시 시도하십시오.",
  },
  verifyRefund: {
    title: "반품 신청",
    hint: "반품 정보 확인 후 인증코드를 제공해 주세요.",
    verifyCode: "인증번호",
    copy: "복사",
    copySucceed: "복사 성공",
    copyFailed: "복사 실패",
    expireTime: "만료 시간",
    shop: "매장",
    soTime: "주문 시간",
    soNo: "POS 주문 번호",
    amount: "환불 금액",
  },
}